import React from 'react'
import { Create } from 'react-admin'
import FormInput from '../invoices/FormInput'

const DraftCreate = () => {

  return (
    <Create>
      <FormInput 
        resource='drafts' 
      />
    </Create>
  )
}

export default DraftCreate